module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "plugins"
    }
  }, [_c('v-toolbar', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "dark": "",
      "tabs": "",
      "extended": "",
      "flat": "",
      "height": "70px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text--darken-4 mt-4"
  }, [_c('h2', [_c('v-icon', {
    staticClass: "grey--text text--darken-4"
  }, [_vm._v("\n          track_changes\n        ")]), _vm._v("\n        " + _vm._s(_vm.$t("settings.available-sensor")) + "\n      ")], 1)]), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "slider-color": "grey",
      "color": "blue-grey lighten-5"
    },
    slot: "extension",
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab', {
    key: "flowsensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#flowsensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.flow")) + "\n      ")]), _vm._v(" "), _c('v-tab', {
    key: "tdssensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#tdssensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.tds")) + "\n      ")]), _vm._v(" "), _c('v-tab', {
    key: "pressuresensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#pressuresensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.pressure")) + "\n      ")]), _vm._v(" "), _c('v-tab', {
    key: "leakagesensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#leakagesensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.leakage")) + "\n      ")]), _vm._v(" "), _c('v-tab', {
    key: "temperaturesensor",
    staticClass: "grey--text text--darken-4",
    attrs: {
      "href": "#temperaturesensor"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("sensor.temperature")) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab-item', {
    key: "flowsensor",
    attrs: {
      "id": "flowsensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchFlowsensor),
      callback: function($$v) {
        _vm.searchFlowsensor = $$v
      },
      expression: "searchFlowsensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersFlowsensor,
      "hide-actions": "",
      "items": _vm.flowsensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchFlowsensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: "tdssensor",
    attrs: {
      "id": "tdssensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchTdssensor),
      callback: function($$v) {
        _vm.searchTdssensor = $$v
      },
      expression: "searchTdssensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersTdssensor,
      "hide-actions": "",
      "items": _vm.tdssensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchTdssensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: "pressuresensor",
    attrs: {
      "id": "pressuresensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchPressuresensor),
      callback: function($$v) {
        _vm.searchPressuresensor = $$v
      },
      expression: "searchPressuresensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersPressuresensor,
      "hide-actions": "",
      "items": _vm.pressuresensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchPressuresensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: "leakagesensor",
    attrs: {
      "id": "leakagesensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchLeakagesensor),
      callback: function($$v) {
        _vm.searchLeakagesensor = $$v
      },
      expression: "searchLeakagesensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersLeakagesensor,
      "hide-actions": "",
      "items": _vm.leakagesensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchLeakagesensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: "temperaturesensor",
    attrs: {
      "id": "temperaturesensor"
    }
  }, [_c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "search",
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchTemperaturesensor),
      callback: function($$v) {
        _vm.searchTemperaturesensor = $$v
      },
      expression: "searchTemperaturesensor"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headersTemperturesensor,
      "hide-actions": "",
      "items": _vm.temperaturesensors,
      "disabled-initial-sort": "",
      "item-key": "id",
      "search": _vm.searchTemperaturesensor
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))])])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-32e15fb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsPlugins.vue
// module id = 1917
// module chunks = 0